/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  Grid,
} from "@material-ui/core";
import { ApplicationState } from "../store";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import {
  getUserData,
} from "../store/users/action";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { getStatus } from "../store/sign/action";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 0.1,
    },
    selectText: {
      fontSize: "14px",
      fontWeight: "bold",
      paddingTop: "3px",
      paddingLeft: "5px",
    },
    code: {
      width: "100%",
      fontSize: "35px",
      backgroundColor: "#ffffff",
      textDecoration: "bold",
      textAlign: "center",
      color: "#333333",
      margin: "0px",
    },
    error: {
      width: "100%",
      fontSize: "20px",
      backgroundColor: "#ffffff",
      textDecoration: "bold",
      textAlign: "center",
      color: "#da2232",
      margin: "0px",
    },
    focused: {},
    outlinedInput: {
      "&$focused $notchedOutline": {
        border: "1px solid #e3e3e3",
      },
    },
    notchedOutline: {},
    button: {
      width: "100%",
      backgroundColor: "#da2232",
      color: "#ffffff",
      borderRadius: "0px",
      "&:hover": {
        cursor: "pointer",
        backgroundColor: "#9b1b25",
        color: "#ffffff",
      },
    },
    title: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#000000",
      paddingBottom: "16px",
    },
    information: {
      fontSize: "13px",
      fontWeight: "normal",
      color: "#000000",
      paddingBottom: "16px",
      paddingTop: "18px",
      textAlign: "center",
    },
    link: {
      color: "#da2232",
    },
    registration: {
      fontSize: "15px",
      fontWeight: "bold",
      color: "#000000",
      paddingBottom: "16px",
      textDecoration: "underline",
    },
    formWidth: {
      maxWidth: "300px",
    },
  })
);

interface PropsFromState {}

interface propsFromDispatch {
  getUserData: () => any;
}

interface IProps {
  isSignOpen: boolean;
  hash: string;
  closeHandler: () => any;
  successHandler?: () => any;
}

type AllProps = IProps & PropsFromState & propsFromDispatch;

const ProfileSignDocument: React.FC<AllProps> = ({
  isSignOpen,
  hash,
  getUserData,
  closeHandler,
  successHandler,
}) => {
  const loopRef = useRef<number>();
  const classes = useStyles();
  const [values, setValues] = useState({
    documentId: undefined,
    status: undefined,
    code: undefined,
  });

  const stopPolling = () => {
    if (loopRef.current) {
      clearInterval(loopRef.current);
      loopRef.current = undefined;
    }
  };

  useEffect(() => {
    stopPolling();

    if (!isSignOpen || !hash) {
      return;
    }

    setValues({
      documentId: undefined,
      status: undefined,
      code: undefined,
    });

    loopRef.current = window.setInterval(async () => {
      let data: any = await getStatus(hash);
      setValues((currentValues) => ({
        ...currentValues,
        status: data.status,
        code:
          data.status === "ERROR" && currentValues.status === "REQUESTED"
            ? undefined
            : data?.code,
      }));
    }, 3000);

    const timeout = window.setTimeout(stopPolling, 90000);

    return () => {
      window.clearTimeout(timeout);
      stopPolling();
    };
  }, [isSignOpen, hash]);

  useEffect(() => {
    if (values.status === "SUCCESS") {
      getUserData();
      stopPolling();
      closeHandler();
      if (successHandler) successHandler();
    }
    if (values.status === "ERROR") {
      stopPolling();
    }
  }, [values]);

  return (
    <Dialog
      open={isSignOpen}
      onBackdropClick={closeHandler}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent>
        <DialogContentText align="center">
          <Box className={classes.title}>
            <FormattedMessage id="profile.signTitle" />
          </Box>
        </DialogContentText>
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="center"
          justify="center"
        >
          <Grid item xs={12} md={6}>
            <Box textAlign="center" pb={2}>
              <img src="/images/smart-id.png" alt="Smart ID" />
            </Box>
            <Box
              display={values?.status === "REQUESTED" ? "block" : "none"}
              className={classes.code}
            >
              {values?.code}
            </Box>
            <Box
              display={
                values?.status !== "REQUESTED" && values?.status !== "ERROR"
                  ? "block"
                  : "none"
              }
              pt={2}
              textAlign="center"
            >
              <FormattedMessage id="profile.signWait" />
            </Box>
            <Box
              display={values?.status === "ERROR" ? "block" : "none"}
              pt={5}
              textAlign="center"
            >
              <FormattedMessage id="profile.signError" />
            </Box>
            <Box className={classes.information}>
              <FormattedMessage id="register.smartIdMore" />{" "}
              <a
                href="https://www.smart-id.com/lv/"
                target="_blank"
                rel="noreferrer"
                className={classes.link}
              >
                {" "}
                <FormattedMessage id="register.smartIdHere" />{" "}
              </a>
              .
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = ({ user }: ApplicationState) => ({});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    getUserData: () => {
      dispatch(getUserData());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileSignDocument);
